import { defineComponent, inferProps, propsWithDefaults, renderSlot, type ReactiveComponent } from "vue-utils"
import BootstrapButton from "./BootstrapButton"
import Form from "./Form"
import FormButtons from "./FormButtons"

interface Props {
	onCancel(): void
	cancelText?: string

	deleteText?: string
	onDelete(): void
}

const ConfirmDeleteForm: ReactiveComponent<Props> = (initialProps, { slots }) => {
	const props = propsWithDefaults(initialProps, {
		cancelText: "Cancel",
		deleteText: "Delete",
	})

	return () => (
		<Form class="flex flex-col" onSubmit={props.onDelete}>
			{renderSlot(slots)}
			<hr class="w-full" />
			<FormButtons>
				<BootstrapButton type="button" color="secondary" onClick={props.onCancel}>
					{props.cancelText}
				</BootstrapButton>
				<BootstrapButton type="submit" color="danger">
					{props.deleteText}
				</BootstrapButton>
			</FormButtons>
		</Form>
	)
}

export default defineComponent(ConfirmDeleteForm, inferProps<Props>())
